import { programmeRevisionsQuery } from "@common/api/maintenance-programme"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@common/components/ui/dialog"
import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import useCustomToast from "@/hooks/use-custom-toast"
import { revisionLabel } from "@/routes/_layout/maintenance-programmes/-lib/revision-label"
import { ReleaseForm } from "../../-components/revision-form/release-form"
import { REVISIONS } from "../../-lib/search"

export const Route = createFileRoute(
  "/_layout/maintenance-programmes_/$programmeId/revisions/release/$revisionId",
)({
  component: ReleaseDialog,
})

function ReleaseDialog(): React.ReactElement {
  const { programmeId, revisionId } = Route.useParams()
  const { data: revisions } = useSuspenseQuery(
    programmeRevisionsQuery({ programme_id: programmeId, ...REVISIONS }),
  )
  const navigate = useNavigate()
  const showToast = useCustomToast()
  const revision = revisions.data.find(({ id }) => id === revisionId)
  const close = () =>
    navigate({
      to: "/maintenance-programmes/$programmeId",
      params: { programmeId },
      search: true,
    })

  return (
    <Dialog open onOpenChange={(next) => !next && close()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{`Release ${revision ? revisionLabel(revision.number) : "revision"}`}</DialogTitle>
          <DialogDescription>
            A released revision can no longer change. It becomes the revision in
            effect from the date below.
          </DialogDescription>
        </DialogHeader>
        {revision && (
          <ReleaseForm
            programmeId={programmeId}
            revision={revision}
            onRelease={(released) => {
              showToast(
                `Released ${revisionLabel(released.number)}`,
                "",
                "success",
              )
              close()
            }}
            onCancel={close}
          />
        )}
      </DialogContent>
    </Dialog>
  )
}
